import React from 'react';
import { PRIVACY_POLICY_HTML } from '../../Public/PrivacyPolicy/privacyPolicyContent';
import '../../Public/legalDoc.scss';

interface PrivacyPolicyModalProps {
  show: boolean;
  onClose: () => void;
  onAccept: () => void;
}

/**
 * Privacy Policy shown inside the PMS wizard, where accepting it enables the consent
 * checkbox.
 *
 * <p>This used to carry its own abridged copy of the policy — a third variant, alongside
 * the page at /privacy-policy and the one the marketing site publishes. Laravel has a
 * single policy and links to it from consent screens, so this renders the same text the
 * /privacy-policy page does: what a user accepts here is now the document Facilon actually
 * publishes.
 */
const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ show, onClose, onAccept }) => {
  if (!show) return null;

  return (
    <div id="privacyModal" className={`modal intro-static-modal ${show ? 'show' : ''}`}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <section className="privacy-policy-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="privacy-policy-text terms-use-text legal-doc"
                  dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_HTML }}
                />
              </div>
            </div>

            <div className="col-sm-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button className="button-1" onClick={onAccept}>Accept</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
